import { jsx as _jsx } from "react/jsx-runtime";
import { Heading as DSHeading } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./heading.module.css";
export const Heading = ({ children , className , element ="h2"  })=>/*#__PURE__*/ _jsx(DSHeading, {
        element: element,
        className: cx(styles.root, className),
        children: children
    });
